import 'javascripts/impression.js'
import 'jquery-ujs'
import 'devbridge-autocomplete'
import { hideNotif, tooltip, eventWithResponse, toggle, scrollTo, scrollThis, hideUntilScroll, dataHrefClick,
  executeJsTemplates, gtmDataLayerEvent, cancelLinkToHash, searchBarLookAhead, top_menu_js } from 'javascripts/general_scripts'
import dynamicVideo from './dynamic_video'
import './load_modals'

window.hideNotif = hideNotif;
window.gitbDynamicVideo = dynamicVideo;

hideNotif(); tooltip();  eventWithResponse(); toggle(); scrollTo(); scrollThis(); hideUntilScroll(); dataHrefClick();
executeJsTemplates(); gtmDataLayerEvent(); cancelLinkToHash(); searchBarLookAhead(); top_menu_js();
dynamicVideo();
if ($('#confirm-email').length) {
  import('javascripts/modal_confirm_email');
}

if ($('#modal-cta').length) {
  import('javascripts/modal_cta');
}

if($('#inappropriate-item-form').length) {
  import('javascripts/modal_inappropriate');
}

if($('#share_this').length) {
  import('javascripts/share_this');
}

if ($('#phone-verification-modal').length && $('.with-phone-verification').length) {
  import('javascripts/verify_phone_button');
}

if (window.dataLayer[0].eligibleForSplitTest) {
  import('javascripts/split_test_campaigns');
}
